import React, { useCallback, useEffect, useRef, useState } from "react";

function Navbar({ openMenu }) {
  const dropdownRef = useRef(null);
  const navbarRef = useRef(null);

  const [dropdownOpen, setDropdownOpen] = useState(null);

  const navigation = [
    {
      id: 1,
      label: "Our team",
      href: "/our-team",
    },
    {
      id: 2,
      label: "Our services",
      href: "#",
      dropdownNav: [
        {
          id: 1,
          label:
            "Diploma of Project Management for ESG Projects with Australia Certification",
          href: "/services/diploma-project-management-esg",
        },
        {
          id: 2,
          label: "Leadership in Sustainability",
          href: "/services/leadership-sustainability",
        },
        {
          id: 3,
          label: "ESG Workshop & Inhouse Training Topics",
          href: "/services/esg-workshop-training",
        },
        {
          id: 4,
          label: "CSR Workshop & Inhouse Training Topics",
          href: "/services/csr-workshop-training",
        },
        {
          id: 5,
          label: "Social Entrepreneurship Workshop & Inhouse Trainings",
          href: "/services/social-entrepreneurship-workshop-training",
        },
      ],
    },
    {
      id: 3,
      label: "Articles",
      href: "/articles",
    },
    {
      id: 4,
      label: "ISA consulting",
      href: "https://sustainability.co.id/",
      target: "_blank",
      rel: "noopener noreferrer",
    },
    {
      id: 5,
      label: "Contact us",
      href: "/contact-us",
    },
    {
      id: 6,
      label: "CCS Online Consultation",
      href: "/ccs-investment",
    },
    {
      id: 7,
      label: "Webinar",
      href: "/webinars",
    },
  ];

  const handleMouseOver = useCallback(
    (e) => {
      if (
        dropdownOpen &&
        !dropdownRef?.current?.contains(e.target) &&
        !navbarRef?.current?.contains(e.target)
      ) {
        setDropdownOpen(null);
      }
    },
    [dropdownOpen, setDropdownOpen]
  );

  useEffect(() => {
    window.addEventListener("mouseover", handleMouseOver);
    return () => {
      window.removeEventListener("mouseover", handleMouseOver);
    };
  }, [handleMouseOver]);

  return (
    <div className={`sticky top-0 shadow-md transition-all z-40 bg-white`}>
      <div
        ref={navbarRef}
        className={`app-nav-container flex justify-between items-center gap-6`}
      >
        <div>
          <a href="/">
            <img
              src={
                "https://storage.googleapis.com/testing_storage_cloudxier/cloudxier-images/49c270d05bc306e2102e328fa00d504a4d3b4a77f824735ba25bfd9281aa72482df5ede49503725295e0b3ba0386083a2805b341f69fe2b58d067164b0403d7ded2f1584f186fb8b7159969ed191c2a774b3e0dec351074d9dc0cfbef81d32b9af1b9c4fcf15b65fa81ee0d53283afece1e6f6684b3d0c9339db/file-1739179063815.png"
              }
              alt="logo"
              className="h-10 md:h-14 xl:h-16"
            />
          </a>
        </div>
        <div
          className={`hidden lg:flex md:space-x-12 text-app-dark-blue font-bold`}
        >
          <ul className="flex items-center md:text-base xl:text-lg">
            {navigation.map((nav) => {
              if (
                nav &&
                (nav.label === "CCS Online Consultation" || nav.label === "Webinar")
              ) {
                return (
                  <button
                    key={nav?.id}
                    className={`px-3 py-2 ml-4 text-xs text-white uppercase rounded-md bg-${
                      nav.label === "CCS Online Consultation"
                        ? "[#0864FB]"
                        : "app-orange"
                    } sm:text-sm sm:px-4`}
                  >
                    <a
                      className="transition-all duration-300 "
                      href={nav.href}
                      target={nav.target}
                      rel={nav.rel}
                    >
                      {nav.label}
                    </a>
                  </button>
                );
              } else {
                return (
                  <li
                    key={nav?.id}
                    onMouseOver={() => setDropdownOpen(nav?.id)}
                    className="px-2 text-center"
                  >
                    <a
                      className="transition-all duration-300 hover:border-b hover:border-app-dark-blue"
                      href={nav.href}
                      target={nav.target}
                      rel={nav.rel}
                    >
                      {nav.label}
                    </a>
                  </li>
                );
              }
            })}
          </ul>
        </div>
        <button
          className="text-base font-bold transition-all text-app-dark-blue lg:hidden active:border-b-2 active:border-white"
          onClick={openMenu}
        >
          Menu
        </button>
      </div>
      <div
        ref={dropdownRef}
        className={`border-t border-app-light-gray/50 p-4 absolute left-0 right-0 z-30 shadow-md bg-white ${
          navigation?.[dropdownOpen - 1]?.dropdownNav?.length > 0
            ? "block"
            : "hidden"
        } transition-all duration-100`}
      >
        <ul className="grid grid-cols-3 gap-10 py-4 list-disc app-main-container lg:py-6 md:text-base xl:text-lg text-app-dark-blue">
          {navigation?.[dropdownOpen - 1]?.dropdownNav?.map((nav) => (
            <li key={nav?.id}>
              <a
                className="transition-all duration-100 hover:border-b hover:border-app-dark-blue hover:font-bold"
                href={nav.href}
                target={nav.target}
                rel={nav.rel}
              >
                {nav.label}
              </a>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
}

export default Navbar;
